<section class="promo-branch-panel" *ngIf="branch">
  <div class="promo-branch-panel__title promo-branch-panel__title--mobile" *ngIf="branchName">
    <p class="promo-branch-panel__name">{{ branchName }}</p>
  </div>

  <div class="promo-branch-panel__header-desktop">
    <div class="promo-branch-panel__identity">
      <span class="promo-branch-panel__logo-wrap" aria-hidden="true">
        <img
          class="promo-branch-panel__logo"
          src="./assets/img/isotipo.svg"
          alt=""
          width="16"
          height="16"
        />
      </span>
      <p class="promo-branch-panel__name">{{ branchName }}</p>
    </div>

    <div class="promo-branch-panel__meta" *ngIf="fullAddress">
      <mat-icon class="promo-branch-panel__meta-icon" svgIcon="room"></mat-icon>
      <p class="promo-branch-panel__meta-text">{{ fullAddress }}</p>
    </div>

    <div class="promo-branch-panel__meta" *ngIf="scheduleLines.length">
      <mat-icon class="promo-branch-panel__meta-icon" svgIcon="access_time"></mat-icon>
      <p class="promo-branch-panel__meta-text">
        <ng-container *ngFor="let line of scheduleLines; let last = last">
          <span class="promo-branch-panel__meta-label">{{ line.label }}</span>
          <span>{{ ' ' }}{{ line.hours }}</span>
          <br *ngIf="!last" />
        </ng-container>
      </p>
    </div>
  </div>

  <div class="promo-branch-panel__map-wrap">
    <div #map class="promo-branch-panel__map"></div>
  </div>

  <div class="promo-branch-panel__footer-mobile">
    <div class="promo-branch-panel__meta" *ngIf="fullAddress">
      <mat-icon class="promo-branch-panel__meta-icon" svgIcon="room"></mat-icon>
      <p class="promo-branch-panel__meta-text">{{ fullAddress }}</p>
    </div>

    <div class="promo-branch-panel__meta" *ngIf="scheduleLines.length">
      <mat-icon class="promo-branch-panel__meta-icon" svgIcon="access_time"></mat-icon>
      <p class="promo-branch-panel__meta-text">
        <ng-container *ngFor="let line of scheduleLines; let last = last">
          <span class="promo-branch-panel__meta-label">{{ line.label }}</span>
          <span>{{ ' ' }}{{ line.hours }}</span>
          <br *ngIf="!last" />
        </ng-container>
      </p>
    </div>
  </div>
</section>
